
import "../../components/css/main.scss";
import pamovationIcon from "../../images/pamovation-icon.png";
import pamovationServices from "../../images/pamovations-services.png";
import pamovationRabbit from "../../images/pamovations-rabbit.png";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import AdvancedTypewriter from "./AdvancedTypewriter";
import MultiTextTypewriter from "./MultiTextTypewriter";
import FramerTypewriter from "./FramerTypewriter";

const Typewriter = ({ text, speed = 100 }) => {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
        let index = 0;
        const interval = setInterval(() => {
            setDisplayedText((prev) => prev + text[index]);
            index++;
            if (index >= text.length) {
                clearInterval(interval);
            }
        }, speed);

        return () => clearInterval(interval);
    }, [text, speed]);

    return (
        <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            className="whitespace-pre text-3xl font-bold font-mono"
        >
            {displayedText}
            <motion.span
                animate={{ opacity: [0, 1, 0] }}
                transition={{ duration: 0.8, repeat: Infinity }}
                className="inline-block"
            >
                |
            </motion.span>
        </motion.span>
    );
};

export const Dashboard = () => {
    return (
        <>
            {/* // <!DOCTYPE html> */}
            <html lang="en">
                <head>
                    <meta charset="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <title>Pamovations - Innovative Tech Solutions</title>
                    <script src="https://cdn.tailwindcss.com"></script>
                    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
                    <link rel="icon" href={pamovationIcon} type="image/x-icon"></link>
                </head>
                <body className="font-sans bg-gray-50">
                    {/* <!-- Navigation --> */}
                    <nav className="bg-white shadow-md sticky top-0 z-50">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="flex justify-between h-16">
                                <div className="flex items-center">
                                    <div className="flex-shrink-0 flex items-center">
                                        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                        <span className="ml-2 text-xl font-bold text-gray-900">Pamovations</span>
                                    </div>
                                    <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                                        <a href="#" className="border-primary text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">Home</a>
                                        <a href="#services" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">Services</a>
                                        <a href="#features" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">Features</a>
                                        <a href="#about" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">About</a>
                                        <a href="#contact" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">Contact</a>
                                    </div>
                                </div>
                                <div className="hidden sm:ml-6 sm:flex sm:items-center">
                                    <button className="bg-primary hover:bg-secondary px-4 py-2 rounded-md text-sm font-medium text-white">Get Started</button>
                                </div>
                                <div className="-mr-2 flex items-center sm:hidden">
                                    <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary" aria-controls="mobile-menu" aria-expanded="false">
                                        <span className="sr-only">Open main menu</span>
                                        <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Mobile menu --> */}
                        <div className="sm:hidden hidden" id="mobile-menu">
                            <div className="pt-2 pb-3 space-y-1">
                                <a href="#" className="bg-primary border-primary text-white block pl-3 pr-4 py-2 border-l-4 text-base font-medium">Home</a>
                                <a href="#services" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">Services</a>
                                <a href="#features" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">Features</a>
                                <a href="#about" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">About</a>
                                <a href="#contact" className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">Contact</a>
                                <div className="mt-4 pl-3 pr-4">
                                    <button className="w-full bg-primary hover:bg-secondary px-4 py-2 rounded-md text-sm font-medium text-white">Get Started</button>
                                </div>
                            </div>
                        </div>
                    </nav>

                    {/* <!-- Hero Section --> */}
                    <div className="relative bg-white overflow-hidden">
                        <div className="max-w-7xl mx-auto">
                            <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
                                <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                                    <div className="sm:text-center lg:text-left">

                                        <div className="mb-5 text-2xl">
                                            <div className="text-gray-500">
                                                WE BUILD,
                                            </div>
                                            <div className="font-bold uppercase">
                                                <FramerTypewriter
                                                    texts={[
                                                        "APPS.",
                                                        "WEBSITES.",
                                                        "NETWORKS."
                                                    ]}
                                                    speed={0.2}
                                                    cursor={true}
                                                />
                                            </div>
                                        </div>

                                        <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                                            <span className="block">Innovative Tech</span>
                                            <span className="block text-primary">Solutions for</span>
                                            <span className="block">Your Business</span>
                                        </h1>
                                        <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                                            Pamovations delivers cutting-edge technology solutions to help your business thrive in the digital age.
                                        </p>
                                        <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                                            <div className="rounded-md shadow">
                                                <a href="#" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-secondary md:py-4 md:text-lg md:px-10">
                                                    Get started
                                                </a>
                                            </div>
                                            <div className="mt-3 sm:mt-0 sm:ml-3">
                                                <a href="#" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-primary bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10">
                                                    Learn more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                            </div>
                        </div>
                        <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                            <img className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src={pamovationServices} alt="Black tech team working" />
                        </div>
                    </div>

                    {/* <!-- Services Section --> */}
                    <div id="services" className="py-12 bg-gray-50">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="lg:text-center">
                                <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Services</h2>
                                <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    What We Offer
                                </p>
                                <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                                    Comprehensive technology solutions tailored to your business needs.
                                </p>
                            </div>

                            <div className="mt-10">
                                <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                                    {/* <!-- Service 1 --> */}
                                    <div className="relative">
                                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div className="ml-16">
                                            <h3 className="text-lg leading-6 font-medium text-gray-900">Custom Software Development</h3>
                                            <p className="mt-2 text-base text-gray-500">
                                                Tailored software solutions designed to streamline your operations and boost productivity.
                                            </p>
                                        </div>
                                    </div>

                                    {/* <!-- Service 2 --> */}
                                    <div className="relative">
                                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                                            </svg>
                                        </div>
                                        <div className="ml-16">
                                            <h3 className="text-lg leading-6 font-medium text-gray-900">AI & Machine Learning</h3>
                                            <p className="mt-2 text-base text-gray-500">
                                                Harness the power of artificial intelligence to gain insights and automate processes.
                                            </p>
                                        </div>
                                    </div>

                                    {/* <!-- Service 3 --> */}
                                    <div className="relative">
                                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                            </svg>
                                        </div>
                                        <div className="ml-16">
                                            <h3 className="text-lg leading-6 font-medium text-gray-900">Cybersecurity Solutions</h3>
                                            <p className="mt-2 text-base text-gray-500">
                                                Protect your digital assets with our comprehensive security assessments and solutions.
                                            </p>
                                        </div>
                                    </div>

                                    {/* <!-- Service 4 --> */}
                                    <div className="relative">
                                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                                            </svg>
                                        </div>
                                        <div className="ml-16">
                                            <h3 className="text-lg leading-6 font-medium text-gray-900">Cloud Computing</h3>
                                            <p className="mt-2 text-base text-gray-500">
                                                Scalable cloud infrastructure to support your business growth and digital transformation.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Features Section --> */}
                    <div id="features" className="py-12 bg-white">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="lg:text-center">
                                <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Features</h2>
                                <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    Why Choose Pamovations
                                </p>
                                <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                                    Our unique approach sets us apart in the tech industry.
                                </p>
                            </div>

                            <div className="mt-10">
                                <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10">
                                    {/* <!-- Feature 1 --> */}
                                    <div className="relative bg-gray-50 p-6 rounded-lg">
                                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                        </div>
                                        <h3 className="text-lg leading-6 font-medium text-gray-900">Cutting-Edge Technology</h3>
                                        <p className="mt-2 text-base text-gray-500">
                                            We stay ahead of the curve with the latest technologies and methodologies.
                                        </p>
                                    </div>

                                    {/* <!-- Feature 2 --> */}
                                    <div className="relative bg-gray-50 p-6 rounded-lg">
                                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                            </svg>
                                        </div>
                                        <h3 className="text-lg leading-6 font-medium text-gray-900">Security First</h3>
                                        <p className="mt-2 text-base text-gray-500">
                                            All our solutions are built with security as a foundational principle.
                                        </p>
                                    </div>

                                    {/* <!-- Feature 3 --> */}
                                    <div className="relative bg-gray-50 p-6 rounded-lg">
                                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                                            </svg>
                                        </div>
                                        <h3 className="text-lg leading-6 font-medium text-gray-900">Scalable Solutions</h3>
                                        <p className="mt-2 text-base text-gray-500">
                                            Our architectures grow with your business, ensuring long-term value.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Testimonials --> */}
                    <div className="bg-slate-500 py-16 sm:py-24">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="lg:text-center">
                                <h2 className="text-base text-blue-200 font-semibold tracking-wide uppercase">Testimonials</h2>
                                <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
                                    What our clients say
                                </p>
                            </div>

                            <div className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-3">
                                {/* <!-- Testimonial 1 --> */}
                                <div className="bg-white p-6 rounded-lg shadow-lg">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <img className="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&h=100&q=80" alt="Sarah Mwangi" />
                                        </div>
                                        <div className="ml-4">
                                            <div className="text-sm font-medium text-gray-900">Sarah Mwangi</div>
                                            <div className="text-sm text-gray-500">CTO, TechForward</div>
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <p className="text-gray-600">
                                            "Pamovations transformed our legacy systems into modern, efficient platforms. Their team was professional and delivered ahead of schedule."
                                        </p>
                                    </div>
                                </div>

                                {/* <!-- Testimonial 2 --> */}
                                <div className="bg-white p-6 rounded-lg shadow-lg">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <img className="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&h=100&q=80" alt="Michael Adebayo" />
                                        </div>
                                        <div className="ml-4">
                                            <div className="text-sm font-medium text-gray-900">Michael Adebayo</div>
                                            <div className="text-sm text-gray-500">CEO, DataSphere</div>
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <p className="text-gray-600">
                                            "The AI solutions Pamovations implemented have given us a competitive edge in our market. Exceptional work!"
                                        </p>
                                    </div>
                                </div>

                                {/* <!-- Testimonial 3 --> */}
                                <div className="bg-white p-6 rounded-lg shadow-lg">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <img className="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&h=100&q=80" alt="Nia Rodriguez" />
                                        </div>
                                        <div className="ml-4">
                                            <div className="text-sm font-medium text-gray-900">Nia Rodriguez</div>
                                            <div className="text-sm text-gray-500">Director of IT, Global Retail</div>
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <p className="text-gray-600">
                                            "From initial consultation to final delivery, Pamovations exceeded our expectations at every step. Highly recommend!"
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- About Section --> */}
                    <div id="about" className="py-12 bg-white">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="lg:text-center">
                                <h2 className="text-base text-primary font-semibold tracking-wide uppercase">About Us</h2>
                                <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    Our Story
                                </p>
                            </div>

                            <div className="mt-10 flex flex-col md:flex-row">
                                <div className="md:w-1/2 md:pr-8">
                                    <p className="text-lg text-gray-500 mb-6">
                                        Founded in 2022, Pamovations began as a small team of passionate technologists with a vision to bridge the gap between business needs and technological innovation.
                                    </p>
                                    <p className="text-lg text-gray-500 mb-6">
                                        Today, we've grown into a trusted partner for businesses across industries, delivering solutions that drive real results.
                                    </p>
                                    <p className="text-lg text-gray-500">
                                        Our team of experts brings diverse experience from top tech companies, ensuring we bring the best practices to every project.
                                    </p>
                                </div>
                                <div className="md:w-1/2 mt-8 md:mt-0">
                                    <img className="rounded-lg shadow-lg" src={pamovationRabbit} alt="Pamovations team of Black professionals" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- CTA Section --> */}
                    <div className="bg-gray-800">
                        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
                            <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                                <span className="block">Ready to innovate?</span>
                                <span className="block text-primary">Start your project with us today.</span>
                            </h2>
                            <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
                                <div className="inline-flex rounded-md shadow">
                                    <a href="#" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-secondary">
                                        Get started
                                    </a>
                                </div>
                                <div className="ml-3 inline-flex rounded-md shadow">
                                    <a href="#" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary bg-white hover:bg-gray-50">
                                        Learn more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Contact Section --> */}
                    <div id="contact" className="bg-white py-16 px-4 sm:px-6 lg:px-8">
                        <div className="max-w-7xl mx-auto">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    Contact Us
                                </h2>
                                <p className="mt-4 text-lg leading-6 text-gray-500">
                                    Have questions or want to discuss a project? Get in touch with our team.
                                </p>
                            </div>
                            <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2">
                                <div>
                                    <div className="bg-gray-50 p-6 rounded-lg">
                                        <h3 className="text-lg font-medium text-gray-900">Contact Information</h3>
                                        <dl className="mt-4 space-y-4">
                                            <div>
                                                <dt className="sr-only">Email</dt>
                                                <dd className="flex">
                                                    <svg className="flex-shrink-0 h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                    </svg>
                                                    <span className="ml-3 text-gray-500">petrojackson5@gmail.com</span>
                                                </dd>
                                            </div>
                                            <div>
                                                <dt className="sr-only">Phone</dt>
                                                <dd className="flex">
                                                    <svg className="flex-shrink-0 h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                    </svg>
                                                    <span className="ml-3 text-gray-500">+255 621 555 169</span>
                                                </dd>
                                            </div>
                                            <div>
                                                <dt className="sr-only">Address</dt>
                                                <dd className="flex">
                                                    <svg className="flex-shrink-0 h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    <span className="ml-3 text-gray-500">Tanzania</span>
                                                </dd>
                                            </div>
                                        </dl>
                                    </div>
                                </div>
                                <div>
                                    <form action="#" method="POST" className="grid grid-cols-1 gap-y-6">
                                        <div>
                                            <label for="name" className="sr-only">Full name</label>
                                            <input type="text" name="name" id="name" autocomplete="name" className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary focus:border-primary border-gray-300 rounded-md" placeholder="Full name" />
                                        </div>
                                        <div>
                                            <label for="email" className="sr-only">Email</label>
                                            <input type="email" name="email" id="email" autocomplete="email" className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary focus:border-primary border-gray-300 rounded-md" placeholder="Email" />
                                        </div>
                                        <div>
                                            <label for="phone" className="sr-only">Phone</label>
                                            <input type="text" name="phone" id="phone" autocomplete="tel" className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary focus:border-primary border-gray-300 rounded-md" placeholder="Phone" />
                                        </div>
                                        <div>
                                            <label for="message" className="sr-only">Message</label>
                                            <textarea id="message" name="message" rows="4" className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-primary focus:border-primary border-gray-300 rounded-md" placeholder="Message"></textarea>
                                        </div>
                                        <div>
                                            <button type="submit" className="inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-primary hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Footer --> */}
                    <footer className="bg-gray-800">
                        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                            <div className="xl:grid xl:grid-cols-3 xl:gap-8">
                                <div className="space-y-8 xl:col-span-1">
                                    <div className="flex items-center">
                                        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                        <span className="ml-2 text-xl font-bold text-white">Pamovations</span>
                                    </div>
                                    <p className="text-gray-300 text-base">
                                        Innovating the future, one solution at a time.
                                    </p>
                                    <div className="flex space-x-6">
                                        <a href="#" className="text-gray-400 hover:text-gray-300">
                                            <span className="sr-only">Facebook</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd" />
                                            </svg>
                                        </a>
                                        <a href="#" className="text-gray-400 hover:text-gray-300">
                                            <span className="sr-only">Twitter</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                                            </svg>
                                        </a>
                                        <a href="#" className="text-gray-400 hover:text-gray-300">
                                            <span className="sr-only">LinkedIn</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path fill-rule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clip-rule="evenodd" />
                                            </svg>
                                        </a>
                                        <a href="#" className="text-gray-400 hover:text-gray-300">
                                            <span className="sr-only">GitHub</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clip-rule="evenodd" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
                                    <div className="md:grid md:grid-cols-2 md:gap-8">
                                        <div>
                                            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Solutions</h3>
                                            <ul className="mt-4 space-y-4">
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Custom Software</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">AI & ML</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Cybersecurity</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Cloud Computing</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="mt-12 md:mt-0">
                                            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Company</h3>
                                            <ul className="mt-4 space-y-4">
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">About</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Careers</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Blog</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Press</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="md:grid md:grid-cols-2 md:gap-8">
                                        <div>
                                            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Support</h3>
                                            <ul className="mt-4 space-y-4">
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Documentation</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Guides</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">API Status</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Contact Support</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="mt-12 md:mt-0">
                                            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Legal</h3>
                                            <ul className="mt-4 space-y-4">
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Privacy</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Terms</a>
                                                </li>
                                                <li>
                                                    <a href="#" className="text-base text-gray-400 hover:text-white">Cookie Policy</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-12 border-t border-gray-700 pt-8">
                                <p className="text-base text-gray-400 text-center">
                                    &copy; 2023 Pamovations, Inc. All rights reserved.
                                </p>
                            </div>
                        </div>
                    </footer>

                    {/* <script>
        // Mobile menu toggle
        document.addEventListener('DOMContentLoaded', function() {
            const mobileMenuButton = document.querySelector('button[aria-controls="mobile-menu"]');
            const mobileMenu = document.getElementById('mobile-menu');
            
            mobileMenuButton.addEventListener('click', function() {
                const expanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', !expanded);
                mobileMenu.classNameList.toggle('hidden');
            });
        });
    </script> */}
                </body>
            </html>
        </>
    );
}